import { useEffect, useRef } from 'react'
import { useAuth } from '@/contexts/AuthContext'
import { getConsumer } from '@/services/cable'
import type { Subscription } from '@rails/actioncable'

interface UseNotificationChannelOptions {
  onNotification: (data: Record<string, unknown>) => void
}

export function useNotificationChannel({ onNotification }: UseNotificationChannelOptions) {
  const { token } = useAuth()
  const subscriptionRef = useRef<Subscription | null>(null)
  const callbackRef = useRef(onNotification)
  callbackRef.current = onNotification

  useEffect(() => {
    if (!token) return

    const consumer = getConsumer(token)
    subscriptionRef.current = consumer.subscriptions.create(
      { channel: 'NotificationChannel' },
      {
        received(data: unknown) {
          callbackRef.current(data as Record<string, unknown>)
        },
      }
    )

    return () => {
      subscriptionRef.current?.unsubscribe()
      subscriptionRef.current = null
    }
  }, [token])
}
